module.exports = __webpack_public_path__ + "img/022.638cb9c3.png";